import { Typography } from '@mui/material';
import React from 'react';
import { DynamicFormBuilderContainer } from '../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
var AlertDetailsDelay = function (props) {
    var jobCardDetails = props.jobCardDetails;
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            bgcolor: '#F4F7FA',
            spacing: 0,
            padding: '12px',
            border: '1px solid ',
            borderColor: '#DEE4EB',
            borderRadius: '8px',
            gap: '16px',
            elements: [{
                    type: FormItemTypes.Box,
                    name: '',
                    columnSize: 12,
                    gap: '4px',
                    pb: '16px',
                    borderBottom: '1px solid',
                    borderColor: '#DEE4EB',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            value: 'Delayed',
                            fontWeight: 'medium',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.Custom,
                            name: '',
                            columnSize: 12,
                            element: function () { /*#__PURE__*/ return React.createElement(Typography, {
                                color: '#8593A3'
                            }, " Job card is delayed by ", /*#__PURE__*/ React.createElement(Typography, {
                                component: 'span',
                                color: '#1B1D21'
                            }, "4 MIN"), ". Please update reason"); }
                        }]
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '16px',
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Estimated date & time:',
                            value: '22 May, 2023 - 5:00 PM',
                            fontWeight: 'medium',
                            fontSize: 'lg',
                            columnSize: 12,
                            labelTypographyProps: {
                                fontSize: 'base',
                                fontWeight: 'medium'
                            }
                        }, {
                            type: FormItemTypes.SingleSelect,
                            name: '',
                            label: 'Reason',
                            placeholder: 'Select reason',
                            columnSize: 12,
                            sx: {
                                bgcolor: 'white',
                                borderRadius: '8px'
                            }
                        }, {
                            type: FormItemTypes.TextInput,
                            name: '',
                            label: 'Remark',
                            multiline: true,
                            minRows: 5,
                            columnSize: 12,
                            sx: {
                                bgcolor: 'white',
                                borderRadius: '8px'
                            }
                        }]
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            justifyContent: 'end',
            padding: '32px 8px 8px 24px',
            elements: [{
                    type: FormItemTypes.Button,
                    name: '',
                    variant: 'outlined',
                    children: 'Discard',
                    columnSize: 0
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    variant: 'contained',
                    children: 'Save',
                    columnSize: 0
                }],
            columnSize: 12
        }];
    return (
    /*#__PURE__*/
    // <MuiStack>
    //     {
    //         false ?
    //             <MuiStack borderRadius={'8px'} direction={'column'} style={{ width: '100%', height: '350px' }}>
    //                 <Skeleton variant="rounded" animation="wave" width={"100%"} height={'100%'} />
    //             </MuiStack>
    //             :
    //             <MuiStack spacing={2} direction={'column'} width={'100%'} bgcolor={systemColor.backgroundColor} padding={1} sx={{ border: `1px solid ${faintGray}`, borderRadius: "8px" }}>
    //                 <Typography variant="h6" color={gray}>
    //                     {/* {`Job card: ${jobCardDetails.jobcardNo} is delayed by ${jobCardDetails.difference} min`}
    //                      */}
    //                     {`Job card: JC0232301 is delayed by 45 min`}
    //                 </Typography>
    //                 <Divider />
    //                 <Grid container>
    //                     <Grid item xs={12}>
    //                         <Typography variant="h6" color={gray}>
    //                             {'Estimated date & time:'}
    //                         </Typography>
    //                     </Grid>
    //                     <Grid item xs={12}>
    //                         <Typography variant="h6" color={gray}>
    //                             22 May, 2023 - 5:00 PM
    //                             {/* {estimatedDeliveryTime} */}
    //                         </Typography>
    //                     </Grid>
    //                 </Grid>
    //             </MuiStack>
    //     }
    // </MuiStack>
    React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridSpacing: 0
    }));
};
export default AlertDetailsDelay;
